import type {LayerProps} from 'react-map-gl/maplibre';

const MAX_ZOOM_LEVEL = 17;

export const heatmapLayer: LayerProps = {
  id: 'heatmap',
  maxzoom: MAX_ZOOM_LEVEL,
  type: 'heatmap',
  paint: {
    // Increase the heatmap weight based on frequency and property magnitude
    'heatmap-weight': ['interpolate', ['linear'], ['get', 'mag'], 0, 0, 6, 1],
    // Increase the heatmap color weight weight by zoom level
    // heatmap-intensity is a multiplier on top of heatmap-weight
    'heatmap-intensity': ['interpolate', ['linear'], ['zoom'], 0, 1, MAX_ZOOM_LEVEL, 3],
    // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
    // Using a sequential color scheme from cool to warm colors
    'heatmap-color': [
      'interpolate',
      ['linear'],
      ['heatmap-density'],
      0,
      'rgba(65,105,225,0)',      // Royal blue with transparency
      0.1,
      'rgba(65,105,225,0.5)',    // Royal blue
      0.3,
      'rgba(135,206,250,0.7)',   // Light sky blue
      0.5,
      'rgba(255,255,0,0.8)',     // Yellow
      0.7,
      'rgba(255,140,0,0.9)',     // Dark orange
      0.9,
      'rgba(255,0,0,1)'          // Pure red
    ],
    // Adjust the heatmap radius by zoom level
    'heatmap-radius': ['interpolate', ['linear'], ['zoom'], 0, 2, MAX_ZOOM_LEVEL, 20],
    // Transition from heatmap to circle layer by zoom level
    'heatmap-opacity': ['interpolate', ['linear'], ['zoom'], 7, 1, 18, 0]
  }
};